<template>
    <div>
        <label class="control-label" :class="[{'sr-only': hideLabel}, {'text-danger': hasErrors}, {'col-md-2': column}]" :for="forId">{{ label }}</label>
        <sup v-if="helpButton">
            <a @click="showHelp" role="button"><i class="fa fa-question-circle" /></a>
        </sup>
        <div><small v-if="helpText"><em>{{ helpText }}</em></small></div>
        <div :class="['field-area', {'alert alert-danger': hasErrors}]">
            <slot />
            <p v-if="hasErrors" class="text-danger">
                {{ displayError }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        // Label text
        label: {
            type: String,
            default: "",
        },
        // Field name used to form help url
        helpLabel: {
            type: String,
            default: '',
        },
        // Actual field name used to form help url
        helpName: {
            type: String,
            default: '',
        },
        isCustomFields: {
            type: Boolean,
            default: false,
        },
        // Id of the form element this is wrapping
        // Should be set to help screen readers
        forId: {
            type: String,
            default: '',
        },
        // Model name to use for help modal
        helpModel: {
            type: String,
            default: '',
        },
        // App label to use for help modal
        helpApp: {
            type: String,
            default: '',
        },
        // Text to show under field
        helpText: {
            type: String,
            default: '',
        },
        helpHtml: {
            type: String,
            default: '',
        },
        // Whether to show help button
        helpButton: {
            type: Boolean,
            default: false,
        },
        // Whether to hide label
        hideLabel: {
            type: Boolean,
            default: false,
        },
        // This should be the actual model name in lowercase, not the verbose name
        type: {
            type: String,
            default: '',
        },
        // This is the alternative type label for help url
        alternativeType: {
            type: String,
            default: ''
        },
        // Array of errors
        errors: {
            type: Array,
            default: () => [],
        },
        column: {
            type: Boolean,
            default: false,
        }
    },
    data: ()=> ({
        showingHelp: false
    }),
    computed: {
        hasErrors: function() {
            return (this.errors.length > 0)
        },
        displayError: function() {
            if (this.hasErrors) {
                return this.errors[0]
            }
            return ''
        },
    },
    methods: {
        showHelp: function() {
            const helpFieldName = (this.helpName && !this.isCustomFields) ? this.helpName : this.helpLabel

            // This URL is passed to the JQuery .load() function in the HelpModal.vue component. It will
            // request the page and render the specified fragment (e.g., .panel-info) as the help content.
            const url = `/help/concepts/${this.helpApp}/${this.type}/${helpFieldName} .panel-info`

            // Optional inline HTML (only EditorDefinition.vue uses this)
            const html = this.helpHtml || null

            this.$emit('showHelp', this.label, url, html)
        },
    },
}
</script>

<style scoped>
.alert-danger {
    margin-bottom: 0px;
}
.alert {
    padding: 5px;
}
.field-area {
    margin-bottom: 1em;
}
</style>
